/* eslint-disable */
import React from "react";
import CommonModal from "../CommonModal";
import UtilService from "../../../services/util";
import _ from "lodash";
import { getProjectSettingList } from "components/DiamondList/DiamondListFunctions";
import { PROJECT_SETTINGS_TYPE } from "constants/Common";
import isEmpty from "lodash/isEmpty";

function BidDisclaimerModal({ checked, handleCancel, handleOk }) {
  let bs = "";
  const blockSettings = UtilService.getLocalStorageItem("popUpValidationMsg");
  if (isEmpty(blockSettings)) {
    getProjectSettingList(
      PROJECT_SETTINGS_TYPE.POP_UP_VALIDATION_MESSAGES,
      (data) => {
        UtilService.setLocalStorageItem(
          data?.data.find(
            ({ type }) =>
              type === PROJECT_SETTINGS_TYPE.POP_UP_VALIDATION_MESSAGES,
          )?.data,
          "bidPopUpValidationMsg",
        );
      },
    );
    bs = UtilService.getLocalStorageItem("bidPopUpValidationMsg");
  }

  let CONFIRM = blockSettings?.["BID"];
  let NOTE = blockSettings?.["NOTE"];
  let indStn = "";
  let usaStn = "";
  let hkStn = "";

  checked.forEach((x) => {
    if (x.locNm === "INDIA") indStn += ` ${x.vStnId}, `;
    if (x.locNm === "USA") usaStn += `${x.vStnId}, `;
    if (x.locNm === "HONGKONG") hkStn += `${x.vStnId}, `;
  });
  let msgs = [];
  let notes = [];
  const comStn = usaStn + ", " + hkStn;
  if (indStn) {
    msgs.push(
      CONFIRM?.INDIA?.replaceAll("$$[vStnId]$$", indStn)
        .replaceAll("$$[locNm]$$", "India")
        .replaceAll(", ,", ", "),
    );
    notes.push(
      NOTE?.INDIA?.replaceAll("$$[vStnId]$$", indStn)
        .replaceAll("$$[locNm]$$", "India")
        .replaceAll(", ,", ", "),
    );
  }

  if (usaStn && hkStn) {
    msgs.push(
      CONFIRM?.HK?.replaceAll("$$[vStnId]$$", comStn)
        .replaceAll("$$[locNm]$$", "U.S.A/HONGKONG")
        .replaceAll(", ,", ", "),
    );
    notes.push(
      NOTE?.HK?.replaceAll("$$[vStnId]$$", comStn)
        .replaceAll("$$[locNm]$$", "U.S.A/HONGKONG")
        .replaceAll(", ,", ", "),
    );
  } else if (usaStn) {
    msgs.push(
      CONFIRM?.USA?.replaceAll("$$[vStnId]$$", usaStn)
        .replaceAll("$$[locNm]$$", "U.S.A")
        .replaceAll(", ,", ", "),
    );
    notes.push(
      NOTE?.USA?.replaceAll("$$[vStnId]$$", usaStn)
        .replaceAll("$$[locNm]$$", "U.S.A")
        .replaceAll(", ,", ", "),
    );
  } else if (hkStn) {
    msgs.push(
      CONFIRM?.HK?.replaceAll("$$[vStnId]$$", hkStn)
        .replaceAll("$$[locNm]$$", "HONGKONG")
        .replaceAll(", ,", ", "),
    );
    notes.push(
      NOTE?.HK?.replaceAll("$$[vStnId]$$", hkStn)
        .replaceAll("$$[locNm]$$", "HONGKONG")
        .replaceAll(", ,", ", "),
    );
  }
  bs && window.location.reload();

  return (
    <CommonModal
      title="Disclaimer"
      submitTitle="I Agree"
      cancelTitle="Quit"
      toggle={handleOk}
      visible={true}
      closable={false}
      handleOk={handleOk}
      handleCancel={handleCancel}
      footerShow
    >
      <div className="detailShow d-flex flex-wrap">
        <div className="detail w-100">
          <span>
            {msgs?.map((x) => (
              <p dangerouslySetInnerHTML={{ __html: x }}></p>
            ))}
            {notes?.map((x) => (
              <p dangerouslySetInnerHTML={{ __html: x }}></p>
            ))}
          </span>
        </div>
      </div>
    </CommonModal>
  );
}

export default BidDisclaimerModal;
